import axios from 'axios';
import store from '../store';
export default {
  namespaced: true,
  
  state: {
    idmodal: '',
    descripcionmodal: '',
    banderamodal: null,
    niveles:[],
    nivel:[]
    
  },
  mutations: {
    
    LoadProductos(state,buscar) {
      //let aux = [];
      state.nivel = state.niveles;

      let aux = state.niveles.filter((x) => x["nombrenivel"].toUpperCase().includes(buscar.toUpperCase()),);
      if (buscar == "") {
        state.nivel = state.niveles;
      } else {
        state.nivel = aux;
      
      }
    },
    
    async  cargardatosniveles(state){
      
      state.niveles = []
      var token = store.state.numero;
      await axios
      .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/niveles", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        state.niveles = response.data.data;
   
      });
      state.nivel= state.niveles
    },




    cambio(state,descripcion){
     
     state.descripcionmodal =descripcion
  
    },
    agregartable(state)  {
      
      //      this.descripcionmodal = descripcion
      var token = store.state.numero;
      var datos = {
        nombrenivel: state.descripcionmodal
      };
      this.banderamodal = store.state.banderamodal
      
    
      
      var datosfalso = state.idmodal;
    
      if (this.banderamodal === true) {
        
        
        axios
        
        .post("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/niveles", datos, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          let tokenn = response.data.token;
          //this.respuesta = <z<
          this.token = tokenn;
      
          
        })
        
        .catch((e) => {
          console.log(e);
        });
      } else {
        
        axios
        
        .post(
          "https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/niveles/UpdateReg/" +
          datosfalso,
          datos,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
          )
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;
          
          })
          
          .catch((e) => {
            console.log(e);
          });
        }
        
      },
      
      
      datosmodal(state, api) {

        state.idmodal = api.idnivel,
        state.descripcionmodal = api.nombrenivel
        
      },
      
      
      
      eliminar(state, api) {
        var token = store.state.numero
        let eliminar = api;
   
        axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/niveles/DeleteReg/" + eliminar,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        
        
        .then((response) => {
          let tokenn = response.data.token;
          //this.respuesta = <z<
          state.eliminer = tokenn;
         
          //this.bandera = true;
        })
        
        .catch((e) => {
          console.log(e);
        });
        
        
        
      },
      
      
      
    },
    actions: {
      
    },
    getters: {
      
      
    },
    
    
    



}